import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { IconName } from '@app/utils/enums/icon-enum';
import { UploadInventoryItemsComponent } from '../upload-inventory-items/upload-inventory-items.component';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '@app/components/shared/icon/icon.component';

@Component({
  selector: 'app-upload-inventory-modal',
  standalone: true,
  imports: [MatDialogModule, UploadInventoryItemsComponent, TranslatePipe, IconComponent],
  templateUrl: './upload-inventory-modal.component.html',
  styleUrl: './upload-inventory-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadInventoryModalComponent {
  private readonly dialogRef = inject(MatDialogRef<UploadInventoryModalComponent>);
  protected readonly iconName = IconName;

  public close(): void {
    this.dialogRef.close();
  }
}
